import React, { useState, useEffect } from "react"
import { useStaticQuery, graphql } from "gatsby"
import SEO from "../components/seo"
import Layout from "../components/layout"
import Hero from "../components/organisms/Hero"
import Gallery from "../components/organisms/Gallery"
import Paragraph from "../components/organisms/Paragraph"
import Perks from "../components/organisms/Perks"
import LearnMore from "../components/organisms/LearnMore"
import Steps from "../components/organisms/Steps"
import JobOffers from "../components/organisms/JobOffers"
import Equality from "../components/molecules/Equality"

const query = graphql`
  {
    allStrapiJobOffers(sort: { order: ASC, fields: order }) {
      edges {
        node {
          id
          Title
          location
          additionalText
          additionalTextSecond
          Equality {
            logo {
              asset
            }
          }
          Content
          Salary
        }
      }
    }
    strapiCareers {
      metaTags {
        description
        ogImage {
          childImageSharp {
            fluid(maxWidth: 1200, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        title
      }
      hero {
        header {
          subtitle
          title
        }
        image {
          childImageSharp {
            fluid(maxWidth: 2400, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
      gallery {
        imageSingle {
          image {
            childImageSharp {
              fluid(maxWidth: 538, quality: 100) {
                ...GatsbyImageSharpFluid_noBase64
              }
            }
          }
        }
      }
      equality {
        Text
        logo {
          asset
        }
      }
      jobOffers {
        sectionHeader {
          subtitle
          title
        }
      }
      learnMore {
        description
        text
      }
      paragraph {
        paragraph
      }
      perksList {
        items {
          heading
          description
          icon {
            publicURL
          }
        }
        sectionHeader {
          subtitle
          title
        }
      }
      process {
        processItems {
          description
          title
        }
        sectionHeader {
          subtitle
          title
        }
      }
    }
  }
`

const CareersPage = () => {
  const data = useStaticQuery(query)
  const seo = data.strapiCareers.metaTags
  const offers = data.allStrapiJobOffers.edges
  const offersHeader = data.strapiCareers.jobOffers.sectionHeader
  const { paragraph } = data.strapiCareers.paragraph
  const learnMore = data.strapiCareers.learnMore
  const perks = data.strapiCareers.perksList
  const process = data.strapiCareers.process
  const hero = data.strapiCareers.hero
  const gallery = data.strapiCareers.gallery
  const equality = data.strapiCareers.equality

  const [isDesktop, setIsDesktop] = useState(true)

  function checkDevice() {
    if (window.innerWidth > 768) {
      setIsDesktop(true)
    } else {
      setIsDesktop(false)
    }
  }

  useEffect(() => {
    checkDevice()
  }, [])

  useEffect(() => {
    window.addEventListener("resize", checkDevice)
    return () => {
      window.removeEventListener("resize", checkDevice)
    }
  })

  return (
    <Layout className="careers">
      <SEO
        image={seo?.ogImage?.childImageSharp?.fluid?.src}
        title={seo.title}
        description={seo.description}
      />
      <Hero
        title={hero.header.title}
        subtitle={hero.header.subtitle}
        type="image"
        showClutchRev={false}
        src={hero?.image?.childImageSharp?.fluid}
      />
      <Paragraph text={paragraph} />
      <Perks
        title={perks.sectionHeader.title}
        subtitle={perks.sectionHeader.subtitle}
        perks={perks.items}
      />
      <Gallery isDesktop={isDesktop} galleryImages={gallery} />
      <Steps
        title={process.sectionHeader.title}
        subtitle={process.sectionHeader.subtitle}
        steps={process.processItems}
      />
      <JobOffers
        offers={offers}
        title={offersHeader.title}
        subtitle={offersHeader.subtitle}
      />
      <Equality
        title="What we stand for?"
        text={equality.Text}
        logos={equality.logo}
      />
      <LearnMore
        linkTitle="Contact Us"
        to="/contact"
        description={learnMore.description}
      >
        {learnMore.text}
      </LearnMore>
    </Layout>
  )
}

export default CareersPage
